import { apiClient } from "../../../shared/api/axios-instance";

export interface Unit {
    id: number;
    name: string;
    symbol: string;
    type: 'weight' | 'volume' | 'count' | 'area' | 'length' | 'other';
    description?: string;
    is_active: boolean;
}

export const unitService = {
    getUnits: async (): Promise<Unit[]> => {
        const response = await apiClient.get('admin/catalog/units');
        return response.data.data;
    },

    createUnit: async (data: Partial<Unit>): Promise<Unit> => {
        const response = await apiClient.post('admin/catalog/units', data);
        return response.data.data;
    },

    updateUnit: async (id: number, data: Partial<Unit>): Promise<Unit> => {
        const response = await apiClient.put(`admin/catalog/units/${id}`, data);
        return response.data.data;
    },

    deleteUnit: async (id: number): Promise<void> => {
        await apiClient.delete(`admin/catalog/units/${id}`);
    }
};
